'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

// At this point, the type that will be used is not known yet.
var InputFileContext = /*#__PURE__*/React__default["default"].createContext({
  value: null,
  getFileProps: function getFileProps() {
    return {};
  },
  getInputProps: function getInputProps() {
    return {};
  },
  isInvalid: false,
  isDisabled: false,
  onDelete: function onDelete() {},
  isReadOnly: false,
  getButtonProps: function getButtonProps() {
    return {};
  },
  setValue: function setValue() {},
  getHtmlProps: function getHtmlProps() {
    return {};
  }
});

// eslint-disable-next-line react/function-component-definition -- Not possible because of the generic type.
function InputFileProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return /*#__PURE__*/React__default["default"].createElement(InputFileContext.Provider, {
    value: value
  }, children);
}
function useInputFileContext() {
  var context = React__default["default"].useContext(InputFileContext);
  if (!context) {
    var error = new Error('useInputFileContext: `context` is undefined. Seems you forgot to wrap component within the Provider');
    error.name = 'ContextError';
    Error === null || Error === void 0 ? void 0 : Error.captureStackTrace(error, React.useContext);
    throw error;
  }
  return context;
}
exports.InputFileProvider = InputFileProvider;
exports.useInputFileContext = useInputFileContext;